import { useAtomValue } from 'jotai';
import { playerGameAggsAtom, playerGameAggsPositionsAtom } from '@/atoms/queries/player/playerGameAggData';
import { loadable } from '@/utils/jotai';

/**
 * Eagerly fetch data needed on the player page. At the moment
 * this is just for player game page, as we load all of a players
 * games in one go rather than page by page. But this could also be
 * used for other things in the future.
 */
export const usePlayerReferenceData = () => {
  useAtomValue(loadable(playerGameAggsAtom));
  useAtomValue(loadable(playerGameAggsPositionsAtom));
};
